import Box from '@mui/material/Box';
import { PropsWithChildren } from 'react';

export function Footer({ children }: PropsWithChildren) {
  return (
    <Box
      sx={(theme) => ({
        alignItems: 'flex-end',
        borderTop: `solid 1px ${theme.palette.divider}`,
        display: 'flex',
        height: '69px',
        p: 2,
      })}
    >
      <Box sx={{ display: 'flex', flex: 1, justifyContent: 'flex-end', gap: 2 }}>
        {children}
      </Box>
    </Box>
  );
}
